import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import InputBox from './InputBox';

/**
 * InputBox for a password, with a show/hide toggle (TASK-2026-10-12-002).
 *
 * Used by Change Password and Add User, inside the app's modals. The Forgot
 * Password flow keeps its own field because it sits on the login card's glass
 * styling, not the dashboard's pill inputs.
 *
 * Takes the same formik-driven props as InputBox; `id` ties the label to the
 * input so the field is reachable by its label.
 */
const PasswordInputBox = ({
  label,
  name,
  formik,
  required = false,
  autoComplete,
  width = '100%',
}) => {
  const [visible, setVisible] = useState(false);
  const lower = label.toLowerCase();

  return (
    <InputBox
      id={`password-${name}`}
      label={label}
      name={name}
      formik={formik}
      required={required}
      type={visible ? 'text' : 'password'}
      autoComplete={autoComplete}
      width={width}
      placeholder={`Enter ${lower}`}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            onClick={() => setVisible((v) => !v)}
            // Keep focus in the field, so toggling does not blur it mid-typing.
            onMouseDown={(e) => e.preventDefault()}
            edge="end"
            size="small"
            aria-label={visible ? `Hide ${lower}` : `Show ${lower}`}
            sx={{ color: '#6B7280' }}
          >
            {visible ? (
              <VisibilityOff sx={{ fontSize: 18 }} />
            ) : (
              <Visibility sx={{ fontSize: 18 }} />
            )}
          </IconButton>
        </InputAdornment>
      }
    />
  );
};

export default PasswordInputBox;
